import { ElementRef, NgModule } from '@angular/core';
import { CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from '@angular/common';
import { NotificationComponent } from './notification/notification.component';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NotificationModule, NOTIFICATION_CONTAINER } from '@progress/kendo-angular-notification';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { GridModule } from '@progress/kendo-angular-grid';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { TranslocoModule } from '@jsverse/transloco';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { LabelModule } from '@progress/kendo-angular-label';
import { RouterModule } from '@angular/router';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { OrderGridComponent } from './order-grid/order-grid.component';
import { OrderPositionsComponent } from './order-grid/order-positions/order-positions.component';
import { ProductGridComponent } from './product-grid/product-grid.component';
import { BasketGridComponent } from './basket-grid/basket-grid.component';
import { CompanyBasketDropdownComponent } from './company-basket-dropdown/company-basket-dropdown.component';
import { PermissionPipe } from './pipes/permission.pipe';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { deviceManufacturersReducers } from '../stores/global/device-manufacturers/device-manufacturers-reducers';
import { DeviceManufacturersEffets } from '../stores/global/device-manufacturers/device-manufacturers-effects';
import { ProductsEffets } from '../stores/global/products/effects';
import { productsReducers } from '../stores/global/products/reducers';
import { SanitizeToDateTimePipe } from './pipes/sanitize-to-date-time.pipe';
import { LoadingIndicationDirective } from './directives/loading-indication.directive';
import { IndicatorsModule } from "@progress/kendo-angular-indicators";



@NgModule({ declarations: [
        NotificationComponent,
        OrderGridComponent,
        OrderPositionsComponent,
        ProductGridComponent,
        BasketGridComponent,
        CompanyBasketDropdownComponent,
        PermissionPipe,
        SanitizeToDateTimePipe,
        LoadingIndicationDirective
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [
        NotificationComponent,
        InputsModule,
        BrowserAnimationsModule,
        NotificationModule,
        FormsModule,
        ReactiveFormsModule,
        ButtonsModule,
        GridModule,
        LayoutModule,
        TranslocoModule,
        DialogsModule,
        LabelModule,
        RouterModule,
        DropDownsModule,
        OrderGridComponent,
        ProductGridComponent,
        BasketGridComponent,
        CompanyBasketDropdownComponent,
        PermissionPipe,
        SanitizeToDateTimePipe,
        LoadingIndicationDirective
    ], imports: [CommonModule,
        InputsModule,
        BrowserAnimationsModule,
        NotificationModule,
        FormsModule,
        ReactiveFormsModule,
        ButtonsModule,
        GridModule,
        LayoutModule,
        TranslocoModule,
        IndicatorsModule,
        DialogsModule,
        LabelModule,
        RouterModule,
        StoreModule.forFeature('deviceManufacturers', deviceManufacturersReducers),
        StoreModule.forFeature('products', productsReducers),
        EffectsModule.forFeature([DeviceManufacturersEffets]),
        EffectsModule.forFeature([ProductsEffets]),
        DropDownsModule], providers: [{
            provide: NOTIFICATION_CONTAINER,
            useFactory: () => {
                //return the container ElementRef, where the notification will be injected
                return { nativeElement: document.body } as ElementRef;
            }
        }, provideHttpClient(withInterceptorsFromDi())] })
export class SharedModule { }
